import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
if (typeof document !== 'undefined') {
  const head = document.head;
  // 1. Only preconnect to CDN (most critical). Fonts load async anyway.
  const pc = document.createElement('link');
  pc.rel = 'preconnect';
  pc.href = 'https://cdn.magicpatterns.com';
  pc.crossOrigin = 'anonymous';
  head.insertBefore(pc, head.firstChild);
  // 2. Preload hero image with fetchpriority
  const p = document.createElement('link');
  p.rel = 'preload';
  p.as = 'image';
  p.href = 'https://cdn.magicpatterns.com/uploads/8tf5B6XkBv43B5SiD8EMnM/mocap_espacio_23.webp';
  p.type = 'image/webp';
  (p as any).fetchPriority = 'high';
  head.appendChild(p);
  // 3. Google Fonts — non-blocking, deferred
  const loadFonts = () => {
    const f = document.createElement('link');
    f.rel = 'stylesheet';
    f.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Poppins:wght@700;800&display=swap';
    f.media = 'print';
    f.onload = function () {
      ;
      (this as HTMLLinkElement).media = 'all';
    };
    head.appendChild(f);
  };
  // Defer font loading slightly to prioritize LCP
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(loadFonts);
  } else {
    setTimeout(loadFonts, 100);
  }
  // 4. Meta Pixel — heavily deferred
  if (!document.querySelector('[data-meta-pixel]')) {
    const load = () => {
      const s = document.createElement('script');
      s.setAttribute('data-meta-pixel', 'true');
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','4736173813277983');fbq('track','PageView');`;
      document.head.appendChild(s);
    };
    typeof requestIdleCallback !== 'undefined' ? requestIdleCallback(load) : setTimeout(load, 5000);
  }
}
render(<App data-id="element-314" />, document.getElementById('root'));